import { rankingItems } from '@/mocks/homeData';

export default function RankingSection() {
  return (
    <section id="ranking" className="py-16 md:py-20 bg-background-50">
      <div className="px-4 md:px-6 max-w-3xl mx-auto">
        <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 text-center">
          热播排行
        </h2>
        <p className="mt-2 text-sm text-foreground-600 text-center">
          实时热度榜 · 大家都在看的电影
        </p>

        <div className="mt-10 rounded-2xl bg-background-100 border border-background-200/70 overflow-hidden">
          {rankingItems.map((item, index) => (
            <a
              key={item.id}
              href="#ranking"
              className={`flex items-center gap-4 px-5 py-4 cursor-pointer transition-colors hover:bg-background-50 ${
                index < rankingItems.length - 1 ? 'border-b border-background-200/70' : ''
              }`}
            >
              <div className={`flex-shrink-0 w-9 h-9 rounded-lg flex items-center justify-center text-sm font-bold ${
                item.rank === 1
                  ? 'bg-accent-500 text-background-50'
                  : item.rank === 2
                  ? 'bg-primary-500 text-background-50'
                  : item.rank === 3
                  ? 'bg-secondary-500 text-background-50'
                  : 'bg-background-200 text-foreground-600'
              }`}>
                {item.rank}
              </div>
              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-2">
                  <span className="text-sm font-semibold text-foreground-900 truncate">
                    {item.title}
                  </span>
                  <span className="px-2 py-0.5 rounded-md bg-secondary-100 text-secondary-700 text-[11px] font-medium whitespace-nowrap">
                    {item.tag}
                  </span>
                </div>
              </div>
              <div className="flex items-center gap-1.5 flex-shrink-0">
                {item.trend === 'up' && (
                  <i className="ri-arrow-up-line text-xs text-accent-500"></i>
                )}
                {item.trend === 'stable' && (
                  <i className="ri-subtract-line text-xs text-foreground-400"></i>
                )}
                <span className="text-sm font-semibold text-accent-600 whitespace-nowrap">
                  {item.heat}热度
                </span>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}